<svg
  class="icon-hamburger"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  [attr.fill]="color"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 4C4 3.44772 4.44772 3 5 3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5H5C4.44772 5 4 4.55228 4 4Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 20C8 19.4477 8.44772 19 9 19L23 19C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21L9 21C8.44772 21 8 20.5523 8 20Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M-1.16564e-07 12C-5.21874e-08 11.4477 0.447715 11 1 11L23 11C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13L1 13C0.447715 13 -1.8094e-07 12.5523 -1.16564e-07 12Z"
    [attr.fill]="color"
  />
</svg>
